// extracted by mini-css-extract-plugin
export default {"localNavHeader":"_3uGWOYo9FI5A1WS5oI0TSU","onScroll":"_2CNweDed0zkCAKlmqXrQ0U","navbar":"_1jq5kkjw82ijVubYkxv_lz","navbarDivider":"_2U9VeQP3cBSK-nVykDPvZQ"};